import React from 'react';
import './quotes.css';

function Quotes() {
  return (
    <>
      <main className="quotesPara">
        <p className="paragraph">
          Mathematics is not about numbers, equations, computations
          or algorithms: It is about understanding. - Willaim Paul, Thurston
        </p>
      </main>
    </>
  );
}
export default Quotes;
